<template>
  <div class="detail_content">
    <div class="detail_label">
      {{titleLabel}}
      <div v-if='!notRequiredFlag' class='require_items_label'>
        {{requiredItemLabel}}
      </div>
    </div>
    <input class='detail_input_field' type="text" v-model='bindValue' @input="inputUpdate">
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    notRequiredFlag: Boolean,
    bindValue: String
  },
  data () {
    return {
    }
  },
  computed: {
    requiredItemLabel () {
      return this.$store.state.error.requiredItemLabel
    }
  },
  methods: {
    inputUpdate (e) {
      this.$emit('inputUpdate', e)
    }
  }
}
</script>
<style scoped>
.detail_input_field {
  width: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/inputBindSection.vue